import { Component, Input } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { CapacitorHttpService } from '@monorepo/services';
import { AnalyticsConfigCacheService } from '../../services/analytics-config-cache.service';
import { THeaderResponse, TLANGUAGE_OPTIONS } from '@monorepo/types';
import { SingleSelectMobileComponent, TOPTION_LIST_ITEM, TSingleSelectMobileModalDismissEmitVal } from '@monorepo/ui';
import { LOCAL_STORAGE_UTILS } from '@monorepo/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'header-setting-popover',
  styleUrls: ['./header-setting-popover.scss'],
  templateUrl: `header-setting-popover.html`,
})
export class HeaderSettingPopover {
  @Input() currentLanguage: TLANGUAGE_OPTIONS | undefined;
  @Input() languageOptions: THeaderResponse['language'] = [];
  constructor(
    private popoverCtrl: PopoverController,
    private modalController: ModalController,
    private capacitorHttpService: CapacitorHttpService,
    private translateService: TranslateService,
    private analyticsConfigCache: AnalyticsConfigCacheService,
  ) {}

  async openLanguageModal() {
    const singleSelectOptions = this.languageOptions.map((lang) => {
      return {
        key: lang.languageCode,
        displayName: `${lang.languageCode} (${lang.languageDisplayLocale})`,
      };
    });
    const selectedVal = await this.openSingleSelect(
      singleSelectOptions,
      this.currentLanguage?.languageCode,
      'Select Language',
    );

    if (selectedVal) {
      this.translateService.use(selectedVal);
      this.changeLanguage(selectedVal);
      await this.analyticsConfigCache.clearCache();
      window.location.reload();
    }
  }

  changeLanguage(languageId: string) {
    LOCAL_STORAGE_UTILS.storeData('locale', languageId);
    this.capacitorHttpService.setCookie({ key: 'locale', value: languageId });
    const defaultLanguage = this.languageOptions.find((lang) => lang.languageCode === languageId);
    if (defaultLanguage)
      this.currentLanguage = {
        ...defaultLanguage,
      };
  }

  async openSingleSelect(
    optionList: TOPTION_LIST_ITEM[],
    selectedItem: string | undefined,
    title: string,
  ): Promise<TOPTION_LIST_ITEM['key'] | undefined> {
    const singleSelectModalComponent = await this.modalController.create({
      component: SingleSelectMobileComponent,
      cssClass: 'm-modal__single-select',
      componentProps: { title, selectedItem, optionList },
    });

    await singleSelectModalComponent.present();

    const dismissEmitValue =
      (await singleSelectModalComponent.onDidDismiss()) as TSingleSelectMobileModalDismissEmitVal;
    switch (dismissEmitValue.role) {
      case 'ON_SELECTED': {
        const selectedVal = dismissEmitValue.data as TOPTION_LIST_ITEM['key'];
        return selectedVal;
      }
    }
    return undefined;
  }

  logoutUser() {
    this.popoverCtrl.dismiss('LOGOUT');
  }
}
